import { useState } from "react";
import { Link } from "react-router-dom";
import { useCalendarStore, useSelectFormStore, useForm } from "../../hooks";
import { SecretaryLayout } from "../Layout";
import { ValuationCalendar } from "../components";
import { SelectForm, LoadingData, ErrorMessage } from "../ui";
import { useFormMessages } from "../hooks";

const formData = {
  headquarterId: "",
  doctorId: "",
};

const formValidations = {
  headquarterId: [(value) => value.length > 0, "Selecciona una sede"],
  doctorId: [(value) => value.length > 0, "Selecciona un doctor"],
};

export const ValuationCalendarPage = () => {
  // Datos de hooks ----------------------------------------//
  const {
    //Props
    isLoadingData,
    isLoading,
    calendar,
    message,

    //Methods
    starGetDoctorsByHeadquarterId,
    starGetScheduleByDoctorId,
  } = useCalendarStore();

  const { isLoading: isLoadingForm, headquarters } = useSelectFormStore([
    "headquarters",
  ]);

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [doctors, setDoctors] = useState([]);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const { formSubmitted, setFormSubmitted, showErrorMessage, messageText } =
    useFormMessages({
      message,
      setValidateForm,
    });

  const { headquarterId, doctorId } = formState;

  const { headquarterIdValid, doctorIdValid } = formValidation;

  // Funciones ---------------------------------------------//
  const headquarterChange = async (event) => {
    onInputChange(event);
    const doctors = await starGetDoctorsByHeadquarterId(event.target.value);
    if (doctors && doctors.length > 0) {
      return setDoctors(doctors);
    }
    return setDoctors([]);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      starGetScheduleByDoctorId(formState);
    }
  };

  // Efectos -----------------------------------------------//

  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <div className="row mb-4">
            <div className="col-xl-9 col-md-6">
              <h5 className="mb-0">Calendario Valoración</h5>

              <nav aria-label="breadcrumb" className="d-inline-block mt-2">
                <ul className="breadcrumb breadcrumb-muted bg-transparent rounded mb-0 p-0">
                  <li className="breadcrumb-item">
                    <Link to="/secretary/dashboard">gosafe</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Calendario Valoración
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          <div className="card border-0 p-4 rounded shadow mb-4">
            <form onSubmit={onSubmit}>
              <div className="row align-items-end g-3">
                {/* Formulario estatico */}
                <>
                  <div className="col-md-4">
                    <SelectForm
                      label={"Sede - ips"}
                      options={headquarters}
                      labelKey={"name"}
                      validation={headquarterIdValid}
                      submit={validateForm}
                      name={"headquarterId"}
                      value={headquarterId}
                      onInputChange={headquarterChange}
                    />
                  </div>
                  {doctors.length > 0 && (
                    <>
                      <div className="col-md-4">
                        <SelectForm
                          label={"Doctor"}
                          options={doctors}
                          labelKey={"name"}
                          validation={doctorIdValid}
                          submit={validateForm}
                          name={"doctorId"}
                          value={doctorId}
                          onInputChange={onInputChange}
                        />
                      </div>
                      <div className="col-md-4">
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={isLoading || isLoadingForm || isLoadingData}
                        >
                          Buscar
                        </button>
                      </div>
                    </>
                  )}
                </>

                {/* Mensajes */}
                <>
                  {(isLoading || isLoadingForm || isLoadingData) && (
                    <div className="col-md-12">
                      <LoadingData />
                    </div>
                  )}
                  {showErrorMessage ||
                    (headquarterId && message?.type === "errorSelect" && (
                      <div className="col-md-12">
                        <ErrorMessage>
                          {messageText || message?.text}
                        </ErrorMessage>
                      </div>
                    ))}
                </>
              </div>
            </form>
          </div>

          {calendar && formSubmitted && <ValuationCalendar />}
        </div>
      </div>
    </SecretaryLayout>
  );
};
